/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * @summary 채팅방 목록 조회
 */
export const chatControllerGetRoomsQueryPageDefault = 1;

export const chatControllerGetRoomsQueryLimitDefault = 20;
export const chatControllerGetRoomsQueryLimitMax = 100;

export const chatControllerGetRoomsQuerySortByDefault = "created_at";
export const chatControllerGetRoomsQuerySortOrderDefault = "desc";
export const chatControllerGetRoomsQueryReadStatusDefault = "all";

export const chatControllerGetRoomsQueryParams = zod
  .object({
    page: zod.coerce
      .number()
      .min(1)
      .default(chatControllerGetRoomsQueryPageDefault)
      .describe("페이지 번호"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(chatControllerGetRoomsQueryLimitMax)
      .default(chatControllerGetRoomsQueryLimitDefault)
      .describe("페이지당 항목 수"),
    sortBy: zod.coerce
      .string()
      .default(chatControllerGetRoomsQuerySortByDefault)
      .describe("정렬 필드"),
    sortOrder: zod
      .enum(["asc", "desc"])
      .default(chatControllerGetRoomsQuerySortOrderDefault)
      .describe("정렬 순서"),
    search: zod.coerce.string().optional().describe("검색어"),
    readStatus: zod
      .enum(["all", "read", "unread"])
      .default(chatControllerGetRoomsQueryReadStatusDefault)
      .describe("읽음 상태 필터"),
  })
  .strict();

export const chatControllerGetRoomsResponseTwoDataItemsItemUnreadCountMin = 0;

export const chatControllerGetRoomsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod.array(
          zod
            .object({
              id: zod.string().describe("채팅방 ID"),
              quoteRequestId: zod.string().describe("견적 요청 ID"),
              buyerId: zod
                .string()
                .describe("구매자 ID (Phase 2: user_id → buyer_id)"),
              supplierId: zod
                .string()
                .describe("공급자 ID (필수) - 채팅방 생성 시 자동 설정됨"),
              quoteResponseId: zod
                .string()
                .optional()
                .describe("견적 응답 ID (채팅방이 견적 응답과 연결된 경우)"),
              contractId: zod
                .string()
                .optional()
                .describe("계약 ID (계약 체결 후 설정)"),
              userInfo: zod
                .object({
                  id: zod.string().nullish(),
                  userId: zod.string().nullish(),
                  name: zod.string().nullish(),
                  email: zod.string().nullish(),
                  phone: zod.string().nullish(),
                  userType: zod.string().nullish(),
                  isActive: zod.boolean().nullish(),
                  profileImageUrl: zod.string().nullish(),
                  authId: zod.string().nullish(),
                  lastLoginAt: zod.string().datetime({}).nullish(),
                  gender: zod.string().nullish(),
                  birthDate: zod.string().nullish(),
                  createdAt: zod.string().datetime({}).nullish(),
                  updatedAt: zod.string().datetime({}).nullish(),
                  trustScore: zod.number().nullish(),
                  trustPercentile: zod
                    .number()
                    .nullish()
                    .describe(
                      "구매자 신뢰도 퍼센타일 (1, 5, 10, 15, 20, 30, null)",
                    ),
                })
                .strict()
                .optional()
                .describe(
                  "구매자 정보 (users + buyers + quote_requests 테이블)",
                ),
              supplierInfo: zod
                .object({
                  id: zod.string(),
                  userId: zod.string().nullish(),
                  email: zod.string().nullish(),
                  phone: zod.string().nullish(),
                  userType: zod.string().nullish(),
                  isActive: zod.boolean().nullish(),
                  trustBadge: zod.string().nullish(),
                  trustPercentile: zod.number().nullish(),
                  certificationTotalScore: zod
                    .number()
                    .nullish()
                    .describe("인증 총점 (0-20)"),
                  totalParticipationScore: zod
                    .number()
                    .nullish()
                    .describe("총 참여 점수 (0-20)"),
                  contractCountScore: zod
                    .number()
                    .nullish()
                    .describe("계약 건수 점수 (0-20)"),
                  totalAmountScore: zod
                    .number()
                    .nullish()
                    .describe("총 금액 점수 (0-20)"),
                  totalCommissionScore: zod
                    .number()
                    .nullish()
                    .describe("총 수수료 점수 (0-20)"),
                  recentParticipationScore: zod
                    .number()
                    .nullish()
                    .describe("최근 참여 점수 (0-20)"),
                  profileImageUrl: zod.string().nullish(),
                  authId: zod.string().nullish(),
                  lastLoginAt: zod.string().datetime({}).nullish(),
                  supplierId: zod.string().nullish(),
                  companyName: zod.string().nullish(),
                  businessNumber: zod.string().nullish(),
                  ceoName: zod.string().nullish(),
                  companyPhone: zod.string().nullish(),
                  managerName: zod.string().nullish(),
                  managerPhone: zod.string().nullish(),
                  businessType: zod.string().nullish(),
                  province: zod.string().nullish(),
                  city: zod.string().nullish(),
                  district: zod.string().nullish(),
                  addressDetail: zod.string().nullish(),
                  addressFull: zod.string().nullish(),
                  companySealUrl: zod.string().nullish(),
                  bankName: zod.string().nullish(),
                  bankAccountNumber: zod.string().nullish(),
                  bankAccountHolder: zod.string().nullish(),
                  trustScore: zod.number().nullish(),
                  createdAt: zod.string().datetime({}).nullish(),
                  updatedAt: zod.string().datetime({}).nullish(),
                })
                .strict()
                .describe("공급자 회사 정보 (users + suppliers 테이블)"),
              quoteRequest: zod
                .object({
                  id: zod.string().describe("견적 요청 ID"),
                  projectName: zod.string().describe("프로젝트명"),
                  requestNumber: zod.string().describe("견적 요청 번호"),
                  status: zod.string().describe("견적 요청 상태"),
                })
                .strict()
                .optional()
                .describe("견적 요청 정보 (JOIN된 데이터)"),
              channelName: zod
                .string()
                .describe("Supabase Realtime 채널명 (Backend SSoT)"),
              status: zod
                .enum([
                  "active",
                  "contract_active",
                  "read_only",
                  "inactive",
                  "CLOSED",
                  "archived",
                ])
                .describe("채팅방 상태")
                .describe("채팅방 상태"),
              lastMessageAt: zod
                .string()
                .optional()
                .describe("마지막 메시지 시간 (ISO 8601 형식)"),
              createdAt: zod.string().describe("생성일시 (ISO 8601 형식)"),
              updatedAt: zod.string().describe("수정일시 (ISO 8601 형식)"),
              lastMessage: zod
                .object({
                  content: zod.string().describe("메시지 내용"),
                  type: zod.string().describe("메시지 타입"),
                  senderType: zod.string().describe("발신자 타입"),
                })
                .strict()
                .optional()
                .describe("마지막 메시지 정보 (성능 최적화)"),
              unreadCount: zod
                .number()
                .min(
                  chatControllerGetRoomsResponseTwoDataItemsItemUnreadCountMin,
                )
                .optional()
                .describe("안읽은 메시지 수 (Watermark 패턴 기반 계산)"),
              lastReadMessageIdBuyer: zod
                .string()
                .optional()
                .describe("마지막으로 읽은 메시지 ID (Watermark - 구매자용)"),
              lastReadMessageIdSupplier: zod
                .string()
                .optional()
                .describe("마지막으로 읽은 메시지 ID (Watermark - 공급자용)"),
              latestQuoteMessage: zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["quote"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  quoteData: zod
                    .object({
                      quoteResponseId: zod.string().optional(),
                      quoteVersionId: zod
                        .string()
                        .optional()
                        .describe("버전 레코드 ID"),
                      versionNumber: zod.number().optional(),
                      totalAmount: zod.number().optional(),
                      taxType: zod
                        .enum(["EXCLUSIVE", "INCLUSIVE"])
                        .optional()
                        .describe(
                          "단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산)",
                        ),
                      supplyAmount: zod
                        .number()
                        .optional()
                        .describe("공급가액 (부가세 제외)"),
                      taxAmount: zod.number().optional().describe("부가세"),
                      previousAmount: zod
                        .number()
                        .optional()
                        .describe("이전 버전 금액"),
                      createdAt: zod
                        .string()
                        .datetime({})
                        .optional()
                        .describe("버전 생성일"),
                      updatedAt: zod
                        .string()
                        .datetime({})
                        .optional()
                        .describe("버전 수정일"),
                      items: zod
                        .array(
                          zod
                            .object({
                              name: zod.string().optional().describe("항목명"),
                              spec: zod.string().optional().describe("사양"),
                              notes: zod.string().optional().describe("설명"),
                              quantity: zod
                                .number()
                                .optional()
                                .describe("수량"),
                              unit: zod.string().optional().describe("단위"),
                              unitPrice: zod
                                .number()
                                .optional()
                                .describe("단가"),
                              amount: zod
                                .number()
                                .optional()
                                .describe("금액 (quantity × unitPrice)"),
                            })
                            .strict(),
                        )
                        .optional(),
                      supplier: zod
                        .object({
                          id: zod
                            .string()
                            .optional()
                            .describe("공급사 사용자 ID"),
                          companyName: zod
                            .string()
                            .optional()
                            .describe("공급사 회사명"),
                          businessNumber: zod
                            .string()
                            .optional()
                            .describe("사업자 등록번호"),
                          ceoName: zod.string().optional().describe("대표자명"),
                          addressFull: zod.string().optional().describe("주소"),
                          businessType: zod
                            .string()
                            .optional()
                            .describe("업종"),
                          companyPhone: zod
                            .string()
                            .optional()
                            .describe("전화번호"),
                          managerName: zod
                            .string()
                            .optional()
                            .describe("담당자명"),
                          managerPhone: zod
                            .string()
                            .optional()
                            .describe("담당자 연락처"),
                          companySealUrl: zod
                            .string()
                            .optional()
                            .describe("회사 인장 URL"),
                          trustBadge: zod
                            .string()
                            .optional()
                            .describe("신뢰도 배지"),
                          isVerified: zod
                            .boolean()
                            .optional()
                            .describe("검증 여부"),
                        })
                        .strict()
                        .optional(),
                      buyer: zod
                        .object({
                          name: zod.string().optional().describe("담당자 이름"),
                          phone: zod
                            .string()
                            .optional()
                            .describe("담당자 연락처"),
                        })
                        .strict()
                        .optional(),
                      pdfUrl: zod
                        .string()
                        .url()
                        .optional()
                        .describe("PDF 다운로드 URL (Supabase Storage)"),
                      description: zod
                        .string()
                        .optional()
                        .describe("견적 설명"),
                      projectName: zod
                        .string()
                        .optional()
                        .describe("프로젝트명"),
                      isContracted: zod
                        .boolean()
                        .optional()
                        .describe("계약 완료 여부 (FREE plan 다운로드 제한용)"),
                      contractId: zod.string().optional().describe("계약 ID"),
                      attachments: zod
                        .array(
                          zod
                            .object({
                              fileName: zod
                                .string()
                                .optional()
                                .describe("파일명"),
                              url: zod
                                .string()
                                .url()
                                .optional()
                                .describe("파일 공개 URL"),
                              filePath: zod
                                .string()
                                .optional()
                                .describe("스토리지 경로 (재서명에 사용)"),
                              fileSize: zod
                                .number()
                                .optional()
                                .describe("파일 크기 (바이트)"),
                              contentType: zod
                                .string()
                                .optional()
                                .describe("MIME 타입"),
                            })
                            .strict(),
                        )
                        .optional()
                        .describe("첨부파일 목록"),
                    })
                    .strict()
                    .optional()
                    .describe("견적서 데이터 (풍부한 정보 포함)"),
                })
                .strict()
                .optional()
                .describe("최신 견적 메시지 (Info Panel 표시용)"),
              isAnonymous: zod
                .boolean()
                .describe(
                  "익명 사용자 여부 (상대방 정보의 블러 처리 여부 결정)",
                ),
              events: zod
                .array(zod.string())
                .describe("구독할 Realtime 이벤트 목록 (Broadcast 패턴)"),
            })
            .strict(),
        ),
        meta: zod
          .object({
            totalCount: zod.number().describe("전체 항목 수"),
            itemCount: zod.number().describe("현재 페이지 항목 수"),
            pageSize: zod.number().describe("페이지당 항목 수"),
            totalPages: zod.number().describe("전체 페이지 수"),
            currentPage: zod.number().describe("현재 페이지"),
            hasNext: zod.boolean().describe("다음 페이지 존재 여부"),
            hasPrev: zod.boolean().describe("이전 페이지 존재 여부"),
            nextCursor: zod
              .string()
              .optional()
              .describe("커서 기반 페이징을 위한 다음 커서"),
          })
          .strict(),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 채팅방 상세 조회
 */
export const chatControllerGetRoomParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerGetRoomResponseTwoDataUnreadCountMin = 0;

export const chatControllerGetRoomResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("채팅방 ID"),
        quoteRequestId: zod.string().describe("견적 요청 ID"),
        buyerId: zod
          .string()
          .describe("구매자 ID (Phase 2: user_id → buyer_id)"),
        supplierId: zod
          .string()
          .describe("공급자 ID (필수) - 채팅방 생성 시 자동 설정됨"),
        quoteResponseId: zod
          .string()
          .optional()
          .describe("견적 응답 ID (채팅방이 견적 응답과 연결된 경우)"),
        contractId: zod
          .string()
          .optional()
          .describe("계약 ID (계약 체결 후 설정)"),
        userInfo: zod
          .object({
            id: zod.string().nullish(),
            userId: zod.string().nullish(),
            name: zod.string().nullish(),
            email: zod.string().nullish(),
            phone: zod.string().nullish(),
            userType: zod.string().nullish(),
            isActive: zod.boolean().nullish(),
            profileImageUrl: zod.string().nullish(),
            authId: zod.string().nullish(),
            lastLoginAt: zod.string().datetime({}).nullish(),
            gender: zod.string().nullish(),
            birthDate: zod.string().nullish(),
            createdAt: zod.string().datetime({}).nullish(),
            updatedAt: zod.string().datetime({}).nullish(),
            trustScore: zod.number().nullish(),
            trustPercentile: zod
              .number()
              .nullish()
              .describe("구매자 신뢰도 퍼센타일 (1, 5, 10, 15, 20, 30, null)"),
          })
          .strict()
          .optional()
          .describe("구매자 정보 (users + buyers + quote_requests 테이블)"),
        supplierInfo: zod
          .object({
            id: zod.string(),
            userId: zod.string().nullish(),
            email: zod.string().nullish(),
            phone: zod.string().nullish(),
            userType: zod.string().nullish(),
            isActive: zod.boolean().nullish(),
            trustBadge: zod.string().nullish(),
            trustPercentile: zod.number().nullish(),
            certificationTotalScore: zod
              .number()
              .nullish()
              .describe("인증 총점 (0-20)"),
            totalParticipationScore: zod
              .number()
              .nullish()
              .describe("총 참여 점수 (0-20)"),
            contractCountScore: zod
              .number()
              .nullish()
              .describe("계약 건수 점수 (0-20)"),
            totalAmountScore: zod
              .number()
              .nullish()
              .describe("총 금액 점수 (0-20)"),
            totalCommissionScore: zod
              .number()
              .nullish()
              .describe("총 수수료 점수 (0-20)"),
            recentParticipationScore: zod
              .number()
              .nullish()
              .describe("최근 참여 점수 (0-20)"),
            profileImageUrl: zod.string().nullish(),
            authId: zod.string().nullish(),
            lastLoginAt: zod.string().datetime({}).nullish(),
            supplierId: zod.string().nullish(),
            companyName: zod.string().nullish(),
            businessNumber: zod.string().nullish(),
            ceoName: zod.string().nullish(),
            companyPhone: zod.string().nullish(),
            managerName: zod.string().nullish(),
            managerPhone: zod.string().nullish(),
            businessType: zod.string().nullish(),
            province: zod.string().nullish(),
            city: zod.string().nullish(),
            district: zod.string().nullish(),
            addressDetail: zod.string().nullish(),
            addressFull: zod.string().nullish(),
            companySealUrl: zod.string().nullish(),
            bankName: zod.string().nullish(),
            bankAccountNumber: zod.string().nullish(),
            bankAccountHolder: zod.string().nullish(),
            trustScore: zod.number().nullish(),
            createdAt: zod.string().datetime({}).nullish(),
            updatedAt: zod.string().datetime({}).nullish(),
          })
          .strict()
          .describe("공급자 회사 정보 (users + suppliers 테이블)"),
        quoteRequest: zod
          .object({
            id: zod.string().describe("견적 요청 ID"),
            projectName: zod.string().describe("프로젝트명"),
            requestNumber: zod.string().describe("견적 요청 번호"),
            status: zod.string().describe("견적 요청 상태"),
          })
          .strict()
          .optional()
          .describe("견적 요청 정보 (JOIN된 데이터)"),
        channelName: zod
          .string()
          .describe("Supabase Realtime 채널명 (Backend SSoT)"),
        status: zod
          .enum([
            "active",
            "contract_active",
            "read_only",
            "inactive",
            "CLOSED",
            "archived",
          ])
          .describe("채팅방 상태")
          .describe("채팅방 상태"),
        lastMessageAt: zod
          .string()
          .optional()
          .describe("마지막 메시지 시간 (ISO 8601 형식)"),
        createdAt: zod.string().describe("생성일시 (ISO 8601 형식)"),
        updatedAt: zod.string().describe("수정일시 (ISO 8601 형식)"),
        lastMessage: zod
          .object({
            content: zod.string().describe("메시지 내용"),
            type: zod.string().describe("메시지 타입"),
            senderType: zod.string().describe("발신자 타입"),
          })
          .strict()
          .optional()
          .describe("마지막 메시지 정보 (성능 최적화)"),
        unreadCount: zod
          .number()
          .min(chatControllerGetRoomResponseTwoDataUnreadCountMin)
          .optional()
          .describe("안읽은 메시지 수 (Watermark 패턴 기반 계산)"),
        lastReadMessageIdBuyer: zod
          .string()
          .optional()
          .describe("마지막으로 읽은 메시지 ID (Watermark - 구매자용)"),
        lastReadMessageIdSupplier: zod
          .string()
          .optional()
          .describe("마지막으로 읽은 메시지 ID (Watermark - 공급자용)"),
        latestQuoteMessage: zod
          .object({
            id: zod.string().describe("메시지 ID"),
            roomId: zod.string().describe("채팅방 ID"),
            senderId: zod.string().describe("발신자 ID"),
            senderType: zod
              .enum(["buyer", "supplier", "system"])
              .describe("발신자 타입"),
            senderName: zod
              .string()
              .optional()
              .describe("발신자 이름 (회사명 또는 사용자명) - Realtime 알림용"),
            messageType: zod.enum(["quote"]).describe("메시지 타입"),
            message: zod.string().describe("메시지 내용"),
            isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
            tempId: zod
              .string()
              .optional()
              .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
            isRead: zod.boolean().describe("읽음 여부"),
            readAt: zod.string().optional().describe("읽은 시간"),
            isDeleted: zod.boolean().describe("삭제 여부"),
            deletedAt: zod.string().optional().describe("삭제 시간"),
            createdAt: zod.string().describe("생성 일시"),
            updatedAt: zod.string().describe("수정 일시"),
            quoteData: zod
              .object({
                quoteResponseId: zod.string().optional(),
                quoteVersionId: zod
                  .string()
                  .optional()
                  .describe("버전 레코드 ID"),
                versionNumber: zod.number().optional(),
                totalAmount: zod.number().optional(),
                taxType: zod
                  .enum(["EXCLUSIVE", "INCLUSIVE"])
                  .optional()
                  .describe(
                    "단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산)",
                  ),
                supplyAmount: zod
                  .number()
                  .optional()
                  .describe("공급가액 (부가세 제외)"),
                taxAmount: zod.number().optional().describe("부가세"),
                previousAmount: zod
                  .number()
                  .optional()
                  .describe("이전 버전 금액"),
                createdAt: zod
                  .string()
                  .datetime({})
                  .optional()
                  .describe("버전 생성일"),
                updatedAt: zod
                  .string()
                  .datetime({})
                  .optional()
                  .describe("버전 수정일"),
                items: zod
                  .array(
                    zod
                      .object({
                        name: zod.string().optional().describe("항목명"),
                        spec: zod.string().optional().describe("사양"),
                        notes: zod.string().optional().describe("설명"),
                        quantity: zod.number().optional().describe("수량"),
                        unit: zod.string().optional().describe("단위"),
                        unitPrice: zod.number().optional().describe("단가"),
                        amount: zod
                          .number()
                          .optional()
                          .describe("금액 (quantity × unitPrice)"),
                      })
                      .strict(),
                  )
                  .optional(),
                supplier: zod
                  .object({
                    id: zod.string().optional().describe("공급사 사용자 ID"),
                    companyName: zod
                      .string()
                      .optional()
                      .describe("공급사 회사명"),
                    businessNumber: zod
                      .string()
                      .optional()
                      .describe("사업자 등록번호"),
                    ceoName: zod.string().optional().describe("대표자명"),
                    addressFull: zod.string().optional().describe("주소"),
                    businessType: zod.string().optional().describe("업종"),
                    companyPhone: zod.string().optional().describe("전화번호"),
                    managerName: zod.string().optional().describe("담당자명"),
                    managerPhone: zod
                      .string()
                      .optional()
                      .describe("담당자 연락처"),
                    companySealUrl: zod
                      .string()
                      .optional()
                      .describe("회사 인장 URL"),
                    trustBadge: zod.string().optional().describe("신뢰도 배지"),
                    isVerified: zod.boolean().optional().describe("검증 여부"),
                  })
                  .strict()
                  .optional(),
                buyer: zod
                  .object({
                    name: zod.string().optional().describe("담당자 이름"),
                    phone: zod.string().optional().describe("담당자 연락처"),
                  })
                  .strict()
                  .optional(),
                pdfUrl: zod
                  .string()
                  .url()
                  .optional()
                  .describe("PDF 다운로드 URL (Supabase Storage)"),
                description: zod.string().optional().describe("견적 설명"),
                projectName: zod.string().optional().describe("프로젝트명"),
                isContracted: zod
                  .boolean()
                  .optional()
                  .describe("계약 완료 여부 (FREE plan 다운로드 제한용)"),
                contractId: zod.string().optional().describe("계약 ID"),
                attachments: zod
                  .array(
                    zod
                      .object({
                        fileName: zod.string().optional().describe("파일명"),
                        url: zod
                          .string()
                          .url()
                          .optional()
                          .describe("파일 공개 URL"),
                        filePath: zod
                          .string()
                          .optional()
                          .describe("스토리지 경로 (재서명에 사용)"),
                        fileSize: zod
                          .number()
                          .optional()
                          .describe("파일 크기 (바이트)"),
                        contentType: zod
                          .string()
                          .optional()
                          .describe("MIME 타입"),
                      })
                      .strict(),
                  )
                  .optional()
                  .describe("첨부파일 목록"),
              })
              .strict()
              .optional()
              .describe("견적서 데이터 (풍부한 정보 포함)"),
          })
          .strict()
          .optional()
          .describe("최신 견적 메시지 (Info Panel 표시용)"),
        isAnonymous: zod
          .boolean()
          .describe("익명 사용자 여부 (상대방 정보의 블러 처리 여부 결정)"),
        events: zod
          .array(zod.string())
          .describe("구독할 Realtime 이벤트 목록 (Broadcast 패턴)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 채팅 메시지 목록 조회
 */
export const chatControllerGetMessagesParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerGetMessagesQueryLimitDefault = 50;
export const chatControllerGetMessagesQueryLimitMax = 100;

export const chatControllerGetMessagesQueryParams = zod
  .object({
    before: zod.coerce
      .string()
      .optional()
      .describe("페이지네이션 커서 (메시지 ID)"),
    limit: zod.coerce
      .number()
      .min(1)
      .max(chatControllerGetMessagesQueryLimitMax)
      .default(chatControllerGetMessagesQueryLimitDefault)
      .describe("페이지당 항목 수"),
  })
  .strict();

export const chatControllerGetMessagesResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        items: zod
          .array(
            zod.union([
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["text"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["attachment"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  attachment: zod
                    .object({
                      id: zod.string().describe("첨부파일 ID"),
                      fileName: zod.string().describe("파일명"),
                      fileSize: zod.number().describe("파일 크기 (바이트)"),
                      fileType: zod.string().describe("파일 타입"),
                      contentType: zod.string().describe("MIME 타입"),
                      url: zod.string().describe("파일 URL"),
                      description: zod
                        .string()
                        .optional()
                        .describe("파일 설명"),
                      isImage: zod.boolean().describe("이미지 파일 여부"),
                      createdAt: zod
                        .string()
                        .describe("업로드 일시 (ISO 8601 형식)"),
                      uploadStatus: zod
                        .string()
                        .describe(
                          "파일 업로드 상태 (pending: 업로드 중, completed: 완료, failed: 실패)",
                        ),
                      hiddenFromSupplier: zod
                        .boolean()
                        .optional()
                        .describe(
                          "true이면 supplier에게 노출하지 않는 첨부 (buyer 채팅창 전용). 계약서류 자동 발급/SEMO 견적서에서 사용.",
                        ),
                    })
                    .strict()
                    .optional()
                    .describe("첨부파일 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["quote"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  quoteData: zod
                    .object({
                      quoteResponseId: zod.string().optional(),
                      quoteVersionId: zod
                        .string()
                        .optional()
                        .describe("버전 레코드 ID"),
                      versionNumber: zod.number().optional(),
                      totalAmount: zod.number().optional(),
                      taxType: zod
                        .enum(["EXCLUSIVE", "INCLUSIVE"])
                        .optional()
                        .describe(
                          "단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산)",
                        ),
                      supplyAmount: zod
                        .number()
                        .optional()
                        .describe("공급가액 (부가세 제외)"),
                      taxAmount: zod.number().optional().describe("부가세"),
                      previousAmount: zod
                        .number()
                        .optional()
                        .describe("이전 버전 금액"),
                      createdAt: zod
                        .string()
                        .datetime({})
                        .optional()
                        .describe("버전 생성일"),
                      updatedAt: zod
                        .string()
                        .datetime({})
                        .optional()
                        .describe("버전 수정일"),
                      items: zod
                        .array(
                          zod
                            .object({
                              name: zod.string().optional().describe("항목명"),
                              spec: zod.string().optional().describe("사양"),
                              notes: zod.string().optional().describe("설명"),
                              quantity: zod
                                .number()
                                .optional()
                                .describe("수량"),
                              unit: zod.string().optional().describe("단위"),
                              unitPrice: zod
                                .number()
                                .optional()
                                .describe("단가"),
                              amount: zod
                                .number()
                                .optional()
                                .describe("금액 (quantity × unitPrice)"),
                            })
                            .strict(),
                        )
                        .optional(),
                      supplier: zod
                        .object({
                          id: zod
                            .string()
                            .optional()
                            .describe("공급사 사용자 ID"),
                          companyName: zod
                            .string()
                            .optional()
                            .describe("공급사 회사명"),
                          businessNumber: zod
                            .string()
                            .optional()
                            .describe("사업자 등록번호"),
                          ceoName: zod.string().optional().describe("대표자명"),
                          addressFull: zod.string().optional().describe("주소"),
                          businessType: zod
                            .string()
                            .optional()
                            .describe("업종"),
                          companyPhone: zod
                            .string()
                            .optional()
                            .describe("전화번호"),
                          managerName: zod
                            .string()
                            .optional()
                            .describe("담당자명"),
                          managerPhone: zod
                            .string()
                            .optional()
                            .describe("담당자 연락처"),
                          companySealUrl: zod
                            .string()
                            .optional()
                            .describe("회사 인장 URL"),
                          trustBadge: zod
                            .string()
                            .optional()
                            .describe("신뢰도 배지"),
                          isVerified: zod
                            .boolean()
                            .optional()
                            .describe("검증 여부"),
                        })
                        .strict()
                        .optional(),
                      buyer: zod
                        .object({
                          name: zod.string().optional().describe("담당자 이름"),
                          phone: zod
                            .string()
                            .optional()
                            .describe("담당자 연락처"),
                        })
                        .strict()
                        .optional(),
                      pdfUrl: zod
                        .string()
                        .url()
                        .optional()
                        .describe("PDF 다운로드 URL (Supabase Storage)"),
                      description: zod
                        .string()
                        .optional()
                        .describe("견적 설명"),
                      projectName: zod
                        .string()
                        .optional()
                        .describe("프로젝트명"),
                      isContracted: zod
                        .boolean()
                        .optional()
                        .describe("계약 완료 여부 (FREE plan 다운로드 제한용)"),
                      contractId: zod.string().optional().describe("계약 ID"),
                      attachments: zod
                        .array(
                          zod
                            .object({
                              fileName: zod
                                .string()
                                .optional()
                                .describe("파일명"),
                              url: zod
                                .string()
                                .url()
                                .optional()
                                .describe("파일 공개 URL"),
                              filePath: zod
                                .string()
                                .optional()
                                .describe("스토리지 경로 (재서명에 사용)"),
                              fileSize: zod
                                .number()
                                .optional()
                                .describe("파일 크기 (바이트)"),
                              contentType: zod
                                .string()
                                .optional()
                                .describe("MIME 타입"),
                            })
                            .strict(),
                        )
                        .optional()
                        .describe("첨부파일 목록"),
                    })
                    .strict()
                    .optional()
                    .describe("견적서 데이터 (풍부한 정보 포함)"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["contract"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  contractInfo: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      paymentId: zod.string().describe("결제 ID"),
                      tid: zod
                        .string()
                        .optional()
                        .describe("Innopay 거래 고유번호 (TID)"),
                      totalAmount: zod.number().describe("총 계약 금액"),
                      contractedAt: zod.string().describe("계약 체결 일시"),
                      status: zod
                        .enum(["complete", "cancelled", "pending"])
                        .describe("계약 상태"),
                      paymentMethod: zod
                        .enum(["CARD", "CASH", "DIRECT", "CMARKET_CARD"])
                        .optional()
                        .describe(
                          "결제 거래의 수단(payment_transactions 축). CMARKET_CARD 는 씨마켓 결제창을 거쳐 공급기업 가맹점으로 승인된 건이다. 계약 시 고른 현금/카드는 이 필드가 아니라 paymentChannel 이다.",
                        ),
                      paymentChannel: zod
                        .enum(["cash", "card"])
                        .nullish()
                        .describe(
                          "계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.",
                        ),
                      taxInvoiceStatus: zod
                        .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                        .nullish()
                        .describe(
                          "씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. NULL 은 아직 아무 통지도 오지 않은 상태다. 현금 계약에서 카드의 isPaid 와 같은 자리를 맡는다 — 스냅샷이 아니라 매 조회마다 계약에서 읽는다.",
                        ),
                      settlesOnCmarket: zod
                        .boolean()
                        .optional()
                        .describe(
                          "이 계약의 대금·계산서를 씨마켓에서 정리하는가(계약-먼저 길인가). 세모 안심결제 계약은 false — 대금은 세모가 이미 받았고 씨마켓에 갈 일이 없다. 카드의 「대금 정리」 칸을 그릴지 이 값 하나로 정한다. 지급 수단으로 되짚지 말 것.",
                        ),
                      supplierCompanyName: zod
                        .string()
                        .optional()
                        .describe("공급자 상호명"),
                      supplierCeoName: zod
                        .string()
                        .optional()
                        .describe("공급자 대표자명"),
                      supplierBusinessNumber: zod
                        .string()
                        .optional()
                        .describe("공급자 사업자등록번호"),
                      supplierAddress: zod
                        .string()
                        .optional()
                        .describe("공급자 주소"),
                      supplierPhone: zod
                        .string()
                        .optional()
                        .describe("공급자 연락처"),
                      supplierEmail: zod
                        .string()
                        .optional()
                        .describe("공급자 이메일"),
                      buyerAgencyName: zod
                        .string()
                        .optional()
                        .describe("구매자 상호명/기관명"),
                      buyerManagerName: zod
                        .string()
                        .optional()
                        .describe("구매자 담당자명"),
                      buyerAddress: zod
                        .string()
                        .optional()
                        .describe("구매자 배송지 주소"),
                      deliveryAddress: zod
                        .string()
                        .optional()
                        .describe("배송지 주소 (legacy or alternate)"),
                      buyerManagerPhone: zod
                        .string()
                        .optional()
                        .describe(
                          "[deprecated] 담당자 개인 연락처 — 더는 채우지 않는다(항상 빈 문자열)",
                        ),
                      buyerOrganizationPhone: zod
                        .string()
                        .optional()
                        .describe(
                          "발주기관 대표번호 (담당자 개인 휴대폰이 아니다)",
                        ),
                      buyerBusinessNumber: zod
                        .string()
                        .optional()
                        .describe("구매자 사업자번호 (보조)"),
                      itemName: zod
                        .string()
                        .optional()
                        .describe("대표 상품/서비스명"),
                      items: zod
                        .array(
                          zod
                            .object({
                              name: zod.string().optional(),
                              spec: zod.string().optional(),
                              quantity: zod.number().optional(),
                              unit: zod.string().optional(),
                              unitPrice: zod.number().optional(),
                              amount: zod.number().optional(),
                            })
                            .strict(),
                        )
                        .optional()
                        .describe("상세 품목 리스트 (거래명세서용)"),
                      authCode: zod
                        .string()
                        .optional()
                        .describe("카드 승인번호 (Innopay)"),
                      reason: zod
                        .string()
                        .optional()
                        .describe("취소 사유 (cancelled 상태일 때)"),
                      isPrepaid: zod
                        .boolean()
                        .optional()
                        .describe(
                          "결제 방법 스냅샷. true=선결제, false=후불결제.",
                        ),
                      paidAt: zod
                        .string()
                        .datetime({})
                        .nullish()
                        .describe("결제 완료 시각. NULL 이면 미결제."),
                    })
                    .strict()
                    .describe("계약 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod.enum(["system"]).describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["payment_pending"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  paymentPendingData: zod
                    .object({
                      moid: zod.string().describe("주문번호 (MOID)"),
                      amount: zod.number().describe("결제 대기 금액"),
                      bankAccount: zod
                        .string()
                        .describe("입금 계좌번호 (가상계좌/무통장)"),
                      createdAt: zod.string().describe("생성 일시"),
                      expiresAt: zod.string().describe("만료 일시 (입금 기한)"),
                      rejectedAt: zod.string().optional().describe("거절 일시"),
                      rejectionReason: zod
                        .string()
                        .optional()
                        .describe("거절 사유"),
                      status: zod
                        .enum(["PENDING", "APPROVED", "REJECTED", "EXPIRED"])
                        .optional()
                        .describe("결제 상태"),
                      approvedAt: zod.string().optional().describe("승인 일시"),
                    })
                    .strict()
                    .describe("입금 대기 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["cancellation_request"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  cancellationRequestData: zod
                    .object({
                      refundId: zod.string().describe("환불 ID"),
                      contractId: zod.string().describe("계약 ID"),
                      requestReason: zod.string().describe("취소 사유"),
                      requesterRole: zod
                        .enum(["buyer", "supplier"])
                        .describe(
                          "취소 요청 주체 (buyer: 발주기관, supplier: 공급사). 승인/반려 버튼은 상대방에게만 노출해야 함. 레거시 메시지는 buyer로 응답됨.",
                        ),
                      rejectionReason: zod
                        .string()
                        .optional()
                        .describe("반려 사유"),
                      tid: zod.string().optional().describe("거래 번호 (환불)"),
                      paymentMethod: zod
                        .enum(["CARD", "CASH", "DIRECT"])
                        .optional()
                        .describe("결제 수단"),
                      totalAmount: zod
                        .number()
                        .optional()
                        .describe("취소 금액"),
                      status: zod
                        .enum(["pending", "approved", "rejected"])
                        .describe("요청 상태"),
                    })
                    .strict()
                    .describe("계약 취소 요청 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["review_submitted"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  reviewSubmittedData: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      reviewId: zod.string().describe("리뷰 ID"),
                      status: zod.enum(["submitted"]).describe("리뷰 상태"),
                    })
                    .strict()
                    .describe("리뷰 작성 완료 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["document_request"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  documentRequestData: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      bidType: zod
                        .enum(["goods", "service", "construction", "sale"])
                        .describe(
                          "c-market 거래유형 (quote_requests.category_type 매핑)",
                        ),
                      documents: zod
                        .array(
                          zod
                            .object({
                              paperCode: zod
                                .number()
                                .describe("c-market 서류 코드"),
                              name: zod.string().describe("서류 이름"),
                              isDefault: zod
                                .boolean()
                                .describe(
                                  "운영자 기본값 여부 - 선택 화면에서 미리 체크",
                                ),
                              autoGenerated: zod
                                .boolean()
                                .describe(
                                  "시스템 자동 생성 가능 여부 (false: 공급사 직접 제출 대상)",
                                ),
                            })
                            .strict(),
                        )
                        .describe(
                          "선택 가능한 계약서류 목록 (pending 카드 렌더용 스냅샷)",
                        ),
                      status: zod
                        .enum(["pending", "requested"])
                        .describe("요청 상태"),
                      issuedPaperCodes: zod
                        .array(zod.number())
                        .describe("발급 완료된 c-market 계약서류 코드"),
                      contractDocuments: zod
                        .array(
                          zod
                            .object({
                              id: zod
                                .string()
                                .describe("contract_documents.id"),
                              paperCode: zod
                                .number()
                                .describe("c-market paperCode"),
                              name: zod.string().describe("서류 이름"),
                              kind: zod
                                .enum(["auto", "auto_pending_input", "manual"])
                                .describe(
                                  "auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출",
                                ),
                              status: zod
                                .enum(["pending", "completed"])
                                .describe("대기(pending) vs 완료(completed)"),
                              fileUrl: zod
                                .object({})
                                .optional()
                                .describe(
                                  "다운로드 가능한 파일 URL (완료 시 존재)",
                                ),
                              fileName: zod
                                .object({})
                                .optional()
                                .describe("원본 파일명 (완료 시 존재)"),
                              fileSize: zod
                                .object({})
                                .optional()
                                .describe("파일 크기 (bytes)"),
                              contentType: zod
                                .object({})
                                .optional()
                                .describe("MIME 타입"),
                              uploadedAt: zod
                                .object({})
                                .optional()
                                .describe("업로드 시각 (ISO 8601)"),
                            })
                            .strict(),
                        )
                        .optional()
                        .describe(
                          '[계약 서류 관리] 카드 항목 목록. status=\"requested\" 로 전환된 이후에만 채워진다.',
                        ),
                      paymentMethod: zod
                        .enum(["prepaid", "postpaid"])
                        .optional()
                        .describe(
                          "견적요청의 결제 방법 스냅샷 (2026-07-31). 2026-08-04 부터 신규는 전량 postpaid 라 카드 렌더 판단에는 쓰지 않는다(표시·디버깅용). 결제 CTA 는 paymentChannel 이 정한다.",
                        ),
                      paymentChannel: zod
                        .enum(["cash", "card"])
                        .nullish()
                        .describe(
                          "계약 시 고른 결제 수단 (contracts.payment_channel 실시간 조회). cash → [계산서 발행요청], card → [카드결제하기]. null 이면 카드가 결제 CTA 를 그리지 않는다 — 컬럼 신설(2026-08-04) 이전 레거시 계약이 여기 해당한다.",
                        ),
                      isPaid: zod
                        .boolean()
                        .optional()
                        .describe(
                          "결제 완료 여부 (contracts.paid_at 유무). CONTRACT 메시지 카드와 같은 판정을 쓴다.",
                        ),
                      taxInvoiceStatus: zod
                        .enum(["REQUESTED", "ISSUED", "CANCELLED"])
                        .nullish()
                        .describe(
                          "씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. 현금 계약에서 isPaid 와 같은 자리를 맡는다.",
                        ),
                      restrictionConfirm: zod
                        .object({
                          answers: zod
                            .array(zod.enum(["YES", "NO"]))
                            .describe("8개 문항 응답 원본"),
                          flaggedIndexes: zod
                            .array(zod.number())
                            .describe(
                              '\"예\"로 응답한 문항 인덱스(0-based). 비어있으면 경고 없음.',
                            ),
                          submittedAt: zod
                            .string()
                            .describe("supplier 제출 시각 (ISO 8601)"),
                          buyerConfirmation: zod
                            .enum(["YES", "NO"])
                            .nullable()
                            .describe(
                              '발주기관 최종 확인 응답. 전 문항 \"NO\" 는 null(확인 절차 없음). \"예\" 포함 상태에서 buyer 미확인이면 null, 확인 후 잠긴다.',
                            ),
                          confirmedAt: zod
                            .object({})
                            .nullable()
                            .describe(
                              "buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.",
                            ),
                        })
                        .strict()
                        .optional()
                        .describe(
                          "paperCode 135(수의계약체결제한여부확인서) 제출 스냅샷 (2026-08-02). 미제출이면 undefined.",
                        ),
                    })
                    .strict()
                    .describe("계약서류 선택 요청 정보"),
                })
                .strict(),
              zod
                .object({
                  id: zod.string().describe("메시지 ID"),
                  roomId: zod.string().describe("채팅방 ID"),
                  senderId: zod.string().describe("발신자 ID"),
                  senderType: zod
                    .enum(["buyer", "supplier", "system"])
                    .describe("발신자 타입"),
                  senderName: zod
                    .string()
                    .optional()
                    .describe(
                      "발신자 이름 (회사명 또는 사용자명) - Realtime 알림용",
                    ),
                  messageType: zod
                    .enum(["contract_restriction_confirm"])
                    .describe("메시지 타입"),
                  message: zod.string().describe("메시지 내용"),
                  isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
                  tempId: zod
                    .string()
                    .optional()
                    .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
                  isRead: zod.boolean().describe("읽음 여부"),
                  readAt: zod.string().optional().describe("읽은 시간"),
                  isDeleted: zod.boolean().describe("삭제 여부"),
                  deletedAt: zod.string().optional().describe("삭제 시간"),
                  createdAt: zod.string().describe("생성 일시"),
                  updatedAt: zod.string().describe("수정 일시"),
                  contractRestrictionConfirmData: zod
                    .object({
                      contractId: zod.string().describe("계약 ID"),
                      documentRequestMessageId: zod
                        .string()
                        .describe("짝이 되는 [계약 서류 관리] 카드 메시지 ID"),
                      answers: zod
                        .array(zod.string())
                        .describe("8개 문항 응답 원본"),
                      flaggedIndexes: zod
                        .array(zod.number())
                        .describe('\"예\"로 응답한 문항 인덱스(0..7)'),
                      submittedAt: zod
                        .string()
                        .describe("공급사 제출 시각 (ISO 8601)"),
                      buyerConfirmation: zod
                        .enum(["YES", "NO"])
                        .nullable()
                        .describe("발주기관 최종 확인 응답. 미제출이면 null."),
                      confirmedAt: zod
                        .object({})
                        .nullable()
                        .describe(
                          "buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.",
                        ),
                    })
                    .strict()
                    .describe("수의계약 체결 제한 확인 요청 정보"),
                })
                .strict(),
            ]),
          )
          .describe("채팅 메시지 목록"),
        nextCursor: zod.string().nullable().describe("다음 커서"),
        hasMore: zod.boolean().describe("추가 데이터 여부"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 메시지 전송
 */
export const chatControllerSendMessageParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerSendMessageBodyContentMax = 1000;

export const chatControllerSendMessageBody = zod
  .object({
    content: zod
      .string()
      .max(chatControllerSendMessageBodyContentMax)
      .describe("메시지 내용 (필수)"),
    replyToId: zod.string().optional().describe("답글 대상 메시지 ID"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

export const chatControllerSendMessageResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("메시지 ID"),
        roomId: zod.string().describe("채팅방 ID"),
        senderId: zod.string().describe("발신자 ID"),
        senderType: zod
          .enum(["buyer", "supplier", "system"])
          .describe("발신자 타입"),
        senderName: zod
          .string()
          .optional()
          .describe("발신자 이름 (회사명 또는 사용자명) - Realtime 알림용"),
        messageType: zod
          .enum([
            "text",
            "attachment",
            "quote",
            "contract",
            "system",
            "payment_pending",
            "cancellation_request",
            "review_submitted",
            "document_request",
            "contract_restriction_confirm",
          ])
          .describe("메시지 타입 (Discriminator)"),
        message: zod.string().describe("메시지 내용"),
        isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
        tempId: zod
          .string()
          .optional()
          .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
        isRead: zod.boolean().describe("읽음 여부"),
        readAt: zod.string().optional().describe("읽은 시간"),
        isDeleted: zod.boolean().describe("삭제 여부"),
        deletedAt: zod.string().optional().describe("삭제 시간"),
        createdAt: zod.string().describe("생성 일시"),
        updatedAt: zod.string().describe("수정 일시"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 선택한 계약서류 자동 생성/제출 요청 (구매자 전용)
 */
export const chatControllerRequestContractDocumentsParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerRequestContractDocumentsBody = zod
  .object({
    messageId: zod.string().uuid().describe("계약서류 선택 요청 메시지 ID"),
    paperCodes: zod
      .array(zod.number())
      .describe("발급할 c-market 계약서류 코드"),
    idempotencyKey: zod
      .string()
      .uuid()
      .describe(
        "c-market 멱등성 키. 같은 사용자 동작의 재시도에는 같은 값을 사용",
      ),
  })
  .strict();

export const chatControllerRequestContractDocumentsResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .array(
        zod
          .object({
            paperCode: zod.number(),
            name: zod.string(),
            fileUrl: zod.string(),
          })
          .strict(),
      )
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 계약 서류 documentInputs 제출 (공급사 전용, 135/164/188/195/222)
 */
export const chatControllerSubmitContractDocumentInputParams = zod
  .object({
    roomId: zod.coerce.string(),
    paperCode: zod.coerce.number(),
  })
  .strict();

export const chatControllerSubmitContractDocumentInputBody = zod
  .object({
    idempotencyKey: zod.string().uuid().describe("c-market 멱등성 키"),
    contractRestrictionConfirm: zod
      .object({
        answers: zod
          .array(zod.enum(["YES", "NO"]))
          .describe(
            '8개 문항 응답 (\"YES\" | \"NO\"). \"YES\" 포함 시 발주기관 확인 절차로 진입.',
          ),
      })
      .strict()
      .optional()
      .describe("paperCode=135 (수의계약체결제한여부확인서) 응답"),
    retireeRoster: zod
      .object({
        rows: zod.array(
          zod
            .object({
              name: zod.string(),
              position: zod.string(),
              joinDate: zod
                .object({})
                .nullish()
                .describe("입사일 (YYYY-MM-DD)"),
              retireType: zod
                .object({})
                .nullish()
                .describe("간부·보직자 직급 (예: 3급)"),
              servicePeriod: zod
                .object({})
                .nullish()
                .describe("근무기간 (개월 단위 숫자 문자열)"),
              etc: zod.object({}).nullish().describe("비고"),
            })
            .strict(),
        ),
      })
      .strict()
      .optional()
      .describe(
        "paperCode=164/188/195/222 응답. 해당없음은 rows=[] 로 전달 (c-market spec)",
      ),
  })
  .strict();

export const chatControllerSubmitContractDocumentInputResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("contract_documents.id"),
        paperCode: zod.number().describe("c-market paperCode"),
        name: zod.string().describe("서류 이름"),
        kind: zod
          .enum(["auto", "auto_pending_input", "manual"])
          .describe(
            "auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출",
          ),
        status: zod
          .enum(["pending", "completed"])
          .describe("대기(pending) vs 완료(completed)"),
        fileUrl: zod
          .object({})
          .optional()
          .describe("다운로드 가능한 파일 URL (완료 시 존재)"),
        fileName: zod
          .object({})
          .optional()
          .describe("원본 파일명 (완료 시 존재)"),
        fileSize: zod.object({}).optional().describe("파일 크기 (bytes)"),
        contentType: zod.object({}).optional().describe("MIME 타입"),
        uploadedAt: zod
          .object({})
          .optional()
          .describe("업로드 시각 (ISO 8601)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary paperCode 135(수의계약체결제한여부확인서) 발주기관 최종 확인 (구매자 전용)
 */
export const chatControllerSubmitContractDocumentBuyerConfirmationParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerSubmitContractDocumentBuyerConfirmationBody = zod
  .object({
    idempotencyKey: zod.string().uuid().describe("c-market 멱등성 키"),
    buyerConfirmation: zod
      .enum(["YES", "NO"])
      .describe("발주기관 최종 확인 응답"),
  })
  .strict();

export const chatControllerSubmitContractDocumentBuyerConfirmationResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("contract_documents.id"),
        paperCode: zod.number().describe("c-market paperCode"),
        name: zod.string().describe("서류 이름"),
        kind: zod
          .enum(["auto", "auto_pending_input", "manual"])
          .describe(
            "auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출",
          ),
        status: zod
          .enum(["pending", "completed"])
          .describe("대기(pending) vs 완료(completed)"),
        fileUrl: zod
          .object({})
          .optional()
          .describe("다운로드 가능한 파일 URL (완료 시 존재)"),
        fileName: zod
          .object({})
          .optional()
          .describe("원본 파일명 (완료 시 존재)"),
        fileSize: zod.object({}).optional().describe("파일 크기 (bytes)"),
        contentType: zod.object({}).optional().describe("MIME 타입"),
        uploadedAt: zod
          .object({})
          .optional()
          .describe("업로드 시각 (ISO 8601)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * c-market /files/{id} 는 인증·Accept 협상 제약, Supabase Storage 는 attachment 헤더로 브라우저에서 직접 열면 다운로드되거나 실패한다. 백엔드가 파일을 받아 magic-number 로 판별한 Content-Type 을 얹어 same-origin 으로 스트리밍한다.
 * @summary 계약 서류 인라인 프리뷰 프록시 (참가자 전용) — 실 Content-Type 판별 후 스트리밍
 */
export const chatControllerPreviewContractDocumentParams = zod
  .object({
    roomId: zod.coerce.string(),
    paperCode: zod.coerce.number(),
  })
  .strict();

/**
 * 프리뷰와 같은 경로로 파일을 받아 Content-Disposition: attachment 로 내려준다. 프론트가 원본 file_url 로 직접 앵커를 걸면 c-market /files/{id} 는 Bearer 토큰이 없어 401 로 죽는다 — 공급사가 올린 Supabase 서명 URL 만 살아남아 "일괄 다운로드에 일부만 담긴다" 는 증상이 된다.
 * @summary 계약 서류 다운로드 프록시 (참가자 전용)
 */
export const chatControllerDownloadContractDocumentParams = zod
  .object({
    roomId: zod.coerce.string(),
    paperCode: zod.coerce.number(),
  })
  .strict();

/**
 * @summary 계약 서류 파일 첨부 (공급사 전용, 직접 제출 서류)
 */
export const chatControllerUploadContractDocumentFileParams = zod
  .object({
    roomId: zod.coerce.string(),
    paperCode: zod.coerce.number(),
  })
  .strict();

export const chatControllerUploadContractDocumentFileBody = zod
  .object({
    file: zod.instanceof(File).optional(),
  })
  .strict();

export const chatControllerUploadContractDocumentFileResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("contract_documents.id"),
        paperCode: zod.number().describe("c-market paperCode"),
        name: zod.string().describe("서류 이름"),
        kind: zod
          .enum(["auto", "auto_pending_input", "manual"])
          .describe(
            "auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출",
          ),
        status: zod
          .enum(["pending", "completed"])
          .describe("대기(pending) vs 완료(completed)"),
        fileUrl: zod
          .object({})
          .optional()
          .describe("다운로드 가능한 파일 URL (완료 시 존재)"),
        fileName: zod
          .object({})
          .optional()
          .describe("원본 파일명 (완료 시 존재)"),
        fileSize: zod.object({}).optional().describe("파일 크기 (bytes)"),
        contentType: zod.object({}).optional().describe("MIME 타입"),
        uploadedAt: zod
          .object({})
          .optional()
          .describe("업로드 시각 (ISO 8601)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 채팅방 읽음 처리
 */
export const chatControllerMarkAsReadParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerMarkAsReadBody = zod
  .object({
    lastReadMessageId: zod
      .string()
      .describe("마지막으로 읽은 메시지 ID (Watermark)"),
  })
  .strict();

/**
 * @summary 파일 업로드 및 메시지 전송
 */
export const chatControllerUploadFileParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerUploadFileBody = zod
  .object({
    file: zod.instanceof(File).optional(),
  })
  .strict();

export const chatControllerUploadFileResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("메시지 ID"),
        roomId: zod.string().describe("채팅방 ID"),
        senderId: zod.string().describe("발신자 ID"),
        senderType: zod
          .enum(["buyer", "supplier", "system"])
          .describe("발신자 타입"),
        senderName: zod
          .string()
          .optional()
          .describe("발신자 이름 (회사명 또는 사용자명) - Realtime 알림용"),
        messageType: zod.enum(["attachment"]).describe("메시지 타입"),
        message: zod.string().describe("메시지 내용"),
        isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
        tempId: zod
          .string()
          .optional()
          .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
        isRead: zod.boolean().describe("읽음 여부"),
        readAt: zod.string().optional().describe("읽은 시간"),
        isDeleted: zod.boolean().describe("삭제 여부"),
        deletedAt: zod.string().optional().describe("삭제 시간"),
        createdAt: zod.string().describe("생성 일시"),
        updatedAt: zod.string().describe("수정 일시"),
        attachment: zod
          .object({
            id: zod.string().describe("첨부파일 ID"),
            fileName: zod.string().describe("파일명"),
            fileSize: zod.number().describe("파일 크기 (바이트)"),
            fileType: zod.string().describe("파일 타입"),
            contentType: zod.string().describe("MIME 타입"),
            url: zod.string().describe("파일 URL"),
            description: zod.string().optional().describe("파일 설명"),
            isImage: zod.boolean().describe("이미지 파일 여부"),
            createdAt: zod.string().describe("업로드 일시 (ISO 8601 형식)"),
            uploadStatus: zod
              .string()
              .describe(
                "파일 업로드 상태 (pending: 업로드 중, completed: 완료, failed: 실패)",
              ),
            hiddenFromSupplier: zod
              .boolean()
              .optional()
              .describe(
                "true이면 supplier에게 노출하지 않는 첨부 (buyer 채팅창 전용). 계약서류 자동 발급/SEMO 견적서에서 사용.",
              ),
          })
          .strict()
          .optional()
          .describe("첨부파일 정보"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();

/**
 * @summary 견적 수정 요청 전송
 */
export const chatControllerSubmitQuoteRevisionParams = zod
  .object({
    roomId: zod.coerce.string(),
  })
  .strict();

export const chatControllerSubmitQuoteRevisionBodyTotalAmountMin = 0;
export const chatControllerSubmitQuoteRevisionBodyTotalAmountMax = 100000000000000;

export const chatControllerSubmitQuoteRevisionBodyTaxAmountMin = 0;
export const chatControllerSubmitQuoteRevisionBodyTaxAmountMax = 10000000000000;

export const chatControllerSubmitQuoteRevisionBodyItemsItemUnitPriceMax = 10000000000000;

export const chatControllerSubmitQuoteRevisionBodyItemsItemQuantityMax = 1000000000;

export const chatControllerSubmitQuoteRevisionBodyItemsItemAmountMin = 0;
export const chatControllerSubmitQuoteRevisionBodyItemsItemAmountMax = 10000000000000;

export const chatControllerSubmitQuoteRevisionBodyDescriptionMax = 500;

export const chatControllerSubmitQuoteRevisionBody = zod
  .object({
    id: zod
      .string()
      .optional()
      .describe("견적 응답 ID (내부용 - PDF 파일명 생성)"),
    versionNumber: zod
      .number()
      .optional()
      .describe("버전 번호 (내부용 - PDF 파일명 생성)"),
    totalAmount: zod
      .number()
      .min(chatControllerSubmitQuoteRevisionBodyTotalAmountMin)
      .max(chatControllerSubmitQuoteRevisionBodyTotalAmountMax)
      .describe("견적 총액 (원, 부가세 10% 포함)"),
    taxAmount: zod
      .number()
      .min(chatControllerSubmitQuoteRevisionBodyTaxAmountMin)
      .max(chatControllerSubmitQuoteRevisionBodyTaxAmountMax)
      .optional()
      .describe("부가가치세(VAT) 금액 (선택사항)"),
    taxType: zod
      .enum(["EXCLUSIVE", "INCLUSIVE"])
      .optional()
      .describe(
        "단가 입력 축 — EXCLUSIVE(공급가액 단가, 기본) | INCLUSIVE(부가세 포함 단가). INCLUSIVE 면 품목 합계가 총액이고 공급가액은 총액에서 역산한 값이다.",
      ),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품목명"),
            unitPrice: zod
              .number()
              .min(1)
              .max(chatControllerSubmitQuoteRevisionBodyItemsItemUnitPriceMax)
              .describe("단가 (원 단위, 부가세 포함)"),
            quantity: zod
              .number()
              .min(1)
              .max(chatControllerSubmitQuoteRevisionBodyItemsItemQuantityMax)
              .describe("수량"),
            unit: zod.string().describe("단위 (예: 세트, EA, 박스)"),
            amount: zod
              .number()
              .min(chatControllerSubmitQuoteRevisionBodyItemsItemAmountMin)
              .max(chatControllerSubmitQuoteRevisionBodyItemsItemAmountMax)
              .describe("품목별 총액 (quantity × unitPrice)"),
            spec1: zod.string().optional().describe("규격 1"),
            spec2: zod.string().optional().describe("규격 2"),
            spec3: zod.string().optional().describe("규격 3"),
            itemCode: zod.string().optional().describe("품목 코드"),
            manufacturer: zod.string().optional().describe("제조사"),
            brand: zod.string().optional().describe("브랜드"),
            updateCatalog: zod
              .number()
              .optional()
              .describe(
                "카탈로그 단가 업데이트 여부 (기존 단가가 있을 때만 참조됨)",
              ),
            itemId: zod
              .string()
              .optional()
              .describe("표준 아이템 ID (items_v2_base.id)"),
          })
          .strict(),
      )
      .nullish()
      .describe(
        "견적 품목 상세 목록 (물품 카테고리일 때 필수, 업체용 - 단가 필수) - 각 품목은 반드시 unit(단위), unitPrice(단가), amount(금액)를 포함해야 합니다. amount = quantity × unitPrice. 총액은 모든 품목의 금액 합계에 10% VAT를 포함한 금액입니다. 제조·용역, 공사, 중고 판매 카테고리에서는 선택사항입니다.",
      ),
    description: zod
      .string()
      .max(chatControllerSubmitQuoteRevisionBodyDescriptionMax)
      .optional()
      .describe(
        '버전 생성 사유 (선택사항) - 예: \"initial_submission\", \"buyer_requested_update\", \"협상 후 금액 조정\"',
      ),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명"),
            url: zod.string().url().describe("파일 공개 URL"),
            filePath: zod
              .string()
              .optional()
              .describe(
                "스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다.",
              ),
            fileSize: zod.number().describe("파일 크기 (바이트)"),
            contentType: zod.string().optional().describe("MIME 타입"),
          })
          .strict(),
      )
      .optional()
      .describe("첨부파일 목록 (선택사항, 최대 10개)"),
    tempId: zod
      .string()
      .optional()
      .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
  })
  .strict();

export const chatControllerSubmitQuoteRevisionResponse = zod
  .object({
    success: zod.boolean().describe("API 호출 성공 여부"),
    data: zod
      .object({
        id: zod.string().describe("메시지 ID"),
        roomId: zod.string().describe("채팅방 ID"),
        senderId: zod.string().describe("발신자 ID"),
        senderType: zod
          .enum(["buyer", "supplier", "system"])
          .describe("발신자 타입"),
        senderName: zod
          .string()
          .optional()
          .describe("발신자 이름 (회사명 또는 사용자명) - Realtime 알림용"),
        messageType: zod.enum(["quote"]).describe("메시지 타입"),
        message: zod.string().describe("메시지 내용"),
        isSystemMessage: zod.boolean().describe("시스템 메시지 여부"),
        tempId: zod
          .string()
          .optional()
          .describe("클라이언트 생성 임시 ID (낙관적 UI 매칭용)"),
        isRead: zod.boolean().describe("읽음 여부"),
        readAt: zod.string().optional().describe("읽은 시간"),
        isDeleted: zod.boolean().describe("삭제 여부"),
        deletedAt: zod.string().optional().describe("삭제 시간"),
        createdAt: zod.string().describe("생성 일시"),
        updatedAt: zod.string().describe("수정 일시"),
        quoteData: zod
          .object({
            quoteResponseId: zod.string().optional(),
            quoteVersionId: zod.string().optional().describe("버전 레코드 ID"),
            versionNumber: zod.number().optional(),
            totalAmount: zod.number().optional(),
            taxType: zod
              .enum(["EXCLUSIVE", "INCLUSIVE"])
              .optional()
              .describe(
                "단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산)",
              ),
            supplyAmount: zod
              .number()
              .optional()
              .describe("공급가액 (부가세 제외)"),
            taxAmount: zod.number().optional().describe("부가세"),
            previousAmount: zod.number().optional().describe("이전 버전 금액"),
            createdAt: zod
              .string()
              .datetime({})
              .optional()
              .describe("버전 생성일"),
            updatedAt: zod
              .string()
              .datetime({})
              .optional()
              .describe("버전 수정일"),
            items: zod
              .array(
                zod
                  .object({
                    name: zod.string().optional().describe("항목명"),
                    spec: zod.string().optional().describe("사양"),
                    notes: zod.string().optional().describe("설명"),
                    quantity: zod.number().optional().describe("수량"),
                    unit: zod.string().optional().describe("단위"),
                    unitPrice: zod.number().optional().describe("단가"),
                    amount: zod
                      .number()
                      .optional()
                      .describe("금액 (quantity × unitPrice)"),
                  })
                  .strict(),
              )
              .optional(),
            supplier: zod
              .object({
                id: zod.string().optional().describe("공급사 사용자 ID"),
                companyName: zod.string().optional().describe("공급사 회사명"),
                businessNumber: zod
                  .string()
                  .optional()
                  .describe("사업자 등록번호"),
                ceoName: zod.string().optional().describe("대표자명"),
                addressFull: zod.string().optional().describe("주소"),
                businessType: zod.string().optional().describe("업종"),
                companyPhone: zod.string().optional().describe("전화번호"),
                managerName: zod.string().optional().describe("담당자명"),
                managerPhone: zod.string().optional().describe("담당자 연락처"),
                companySealUrl: zod
                  .string()
                  .optional()
                  .describe("회사 인장 URL"),
                trustBadge: zod.string().optional().describe("신뢰도 배지"),
                isVerified: zod.boolean().optional().describe("검증 여부"),
              })
              .strict()
              .optional(),
            buyer: zod
              .object({
                name: zod.string().optional().describe("담당자 이름"),
                phone: zod.string().optional().describe("담당자 연락처"),
              })
              .strict()
              .optional(),
            pdfUrl: zod
              .string()
              .url()
              .optional()
              .describe("PDF 다운로드 URL (Supabase Storage)"),
            description: zod.string().optional().describe("견적 설명"),
            projectName: zod.string().optional().describe("프로젝트명"),
            isContracted: zod
              .boolean()
              .optional()
              .describe("계약 완료 여부 (FREE plan 다운로드 제한용)"),
            contractId: zod.string().optional().describe("계약 ID"),
            attachments: zod
              .array(
                zod
                  .object({
                    fileName: zod.string().optional().describe("파일명"),
                    url: zod
                      .string()
                      .url()
                      .optional()
                      .describe("파일 공개 URL"),
                    filePath: zod
                      .string()
                      .optional()
                      .describe("스토리지 경로 (재서명에 사용)"),
                    fileSize: zod
                      .number()
                      .optional()
                      .describe("파일 크기 (바이트)"),
                    contentType: zod.string().optional().describe("MIME 타입"),
                  })
                  .strict(),
              )
              .optional()
              .describe("첨부파일 목록"),
          })
          .strict()
          .optional()
          .describe("견적서 데이터 (풍부한 정보 포함)"),
      })
      .strict()
      .optional(),
    error: zod
      .object({
        code: zod.string().describe("에러 코드"),
        message: zod.string().describe("에러 메시지"),
        details: zod.object({}).optional().describe("상세 정보"),
      })
      .strict()
      .optional()
      .describe("에러 정보 (실패 시에만 포함)"),
    timestamp: zod.string().datetime({}).describe("응답 생성 시각 (ISO 8601)"),
    statusCode: zod.number().optional().describe("HTTP 상태 코드"),
    message: zod.string().optional().describe("요청 처리 메시지"),
  })
  .strict();
